import { ROLE_CONVENIO, ROLE_INTERNAL_DOCTOR, ROLE_LABEL } from "../../../types/role";

const loggedUserTitle = (roleId: number) => {
  const userTitles = [
    {
      role_id: 1,
      text: "Administrador Senne",
    },
    {
      role_id: 2,
      text: "Hospitais",
    },
    {
      role_id: 3,
      text: "Paciente",
    },
    {
      role_id: 4,
      text: "Médico",
    },
    {
      role_id: 5,
      // ponytail: role 5 delega ao rótulo central (types/role.ts) — fonte única
      text: ROLE_LABEL[ROLE_INTERNAL_DOCTOR],
    },
    {
      // Faltava. Usuário de convênio aparecia SEM papel nenhum no cabeçalho e na
      // lista do "ver como" — a lista local nasceu com cinco papéis e o convênio
      // entrou depois só no mapa central.
      role_id: 6,
      text: ROLE_LABEL[ROLE_CONVENIO],
    },
  ];

  return userTitles.find((title) => title.role_id === roleId)?.text;
};

export default loggedUserTitle;
